import { CART_RECEIVE, CART_MINIMUM_QUANTITY_ERROR } from '../constants';

export const cart = (
    state = { quantity: 0, orderTotal: 0, showInfo: false },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_MINIMUM_QUANTITY_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
